module.exports = [
  {
    id: 'freshness',
    options: [
      { value: 'day' },
      { value: 'week' },
      { value: 'month' },
    ],
  },
];
